import { render, staticRenderFns } from "./transcript-ring-gauge.vue?vue&type=template&id=db32e4e0&scoped=true&"
import script from "./transcript-ring-gauge.vue?vue&type=script&lang=js&"
export * from "./transcript-ring-gauge.vue?vue&type=script&lang=js&"
import style0 from "./transcript-ring-gauge.vue?vue&type=style&index=0&id=db32e4e0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db32e4e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db32e4e0')) {
      api.createRecord('db32e4e0', component.options)
    } else {
      api.reload('db32e4e0', component.options)
    }
    module.hot.accept("./transcript-ring-gauge.vue?vue&type=template&id=db32e4e0&scoped=true&", function () {
      api.rerender('db32e4e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/transcript-ring-gauge/transcript-ring-gauge.vue"
export default component.exports